import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { AuthField, AuthSubmit, authLinkClass } from "./AuthField";
import { useScriptMode } from "../../contexts/ScriptModeContext";
import { useForgotPasswordMutation } from "../../api/authApi";
import { useToast } from "../../components/ui/Toast";

export default function ForgotPasswordPage() {
  const { t } = useScriptMode();
  const toast = useToast();
  const [submitted, setSubmitted] = useState(false);

  const schema = yup.object({
    email: yup.string().email(t("validation_email")).required(t("validation_required")),
  });
  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
    defaultValues: { email: "" },
  });

  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();

  const onSubmit = async (values) => {
    const result = await forgotPassword(values);
    // Per spec: enumeration protection — show success regardless of error
    setSubmitted(true);
    if (result.error && result.error.type === "MAINTENANCE") {
      toast.error(t("maintenance_message"));
    }
  };

  return (
    <AuthLayout
      title={t("forgot_title")}
      footer={
        <p className="text-center">
          <Link to="/giris" className={authLinkClass}>
            {t("forgot_back_to_login")}
          </Link>
        </p>
      }
    >
      {submitted ? (
        <div className="rounded-xl bg-terakkiBrandMist/60 px-4 py-3 text-base text-terakkiBrandDeep">
          {t("forgot_success")}
        </div>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-5">
          <AuthField
            id="forgot-email"
            label={t("email")}
            type="email"
            autoComplete="email"
            placeholder="ornek@mail.com"
            disabled={isLoading}
            error={errors.email?.message}
            {...register("email")}
          />
          <AuthSubmit loading={isLoading}>{t("forgot_submit")}</AuthSubmit>
        </form>
      )}
    </AuthLayout>
  );
}
